import moment from 'moment';

export default class QmsRow {
  constructor({
    id,
    rowNum = 0,
    employeeCode,
    storeCode,
    employeeName,
    department,
    queryType,
    queryDescription,
    closureRemarks,
    employeeRefImages,
    closureRefImages,
    isClosed,
    is_closed: isClosedSnake,
    closedAt,
    closedByName,
    closedByLevel,
    currentEscalationLevel,
    escalationHistory,
    tatTime,
    submittedByName,
    createdAt,
    updatedAt
  }) {
    this.id = id || '';
    this.rowNum = rowNum;
    this.employeeCode = employeeCode || '';
    this.storeCode = storeCode || '';
    this.employeeName = employeeName || '';
    this.department = department || '';
    this.queryType = queryType || '';
    this.queryDescription = queryDescription || '';
    this.closureRemarks = closureRemarks || '';
    this.employeeRefImages = (employeeRefImages || [])
      .map(item => {
        if (typeof item === 'string') {
          return item.split('?')[0];
        }
        return item && item.url ? String(item.url).split('?')[0] : '';
      })
      .filter(Boolean);
    this.closureRefImages = (closureRefImages || [])
      .map(item => {
        if (typeof item === 'string') {
          return item.split('?')[0];
        }
        return item && item.url ? String(item.url).split('?')[0] : '';
      })
      .filter(Boolean);
    this.isClosed = isClosed != null ? isClosed : isClosedSnake;
    this.closedAt = closedAt ? moment(closedAt).format('DD-MM-YYYY HH:mm') : '';
    this.closedByName = closedByName || '';
    this.currentEscalationLevel = currentEscalationLevel || '';
    this.escalationHistory = Array.isArray(escalationHistory) ? escalationHistory : [];
    this.closedByLevel = closedByLevel || '';
    this.tatTime = tatTime != null ? tatTime : '';
    this.submittedByName = submittedByName || '';
    this.createdAt = createdAt ? moment(createdAt).format('DD-MM-YYYY HH:mm') : '';
    this.updatedAt = updatedAt ? moment(updatedAt).format('DD-MM-YYYY HH:mm') : '';
  }
}
